/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { userPolicyTypeEnumSchema } from "./userPolicyTypeEnumSchema.ts";
import { z } from "zod";

export const updatePolicyRequestModelSchema = z.object({
    "fileId": z.string().uuid().describe("Id файла политики"),
"languageCode": z.string().max(3).describe("Код языка"),
"type": z.lazy(() => userPolicyTypeEnumSchema).describe("Тип политики. \n\r\n1 - Пользовательское соглашение \n\r\n2 - Политика обработки данных \n<p>Возможные значения:</p>\n<ul>\n<li><b>1 - TermsOfUse</b>: Пользовательское соглашение.</li>\n<li><b>2 - PrivacyPolicy</b>: Политика обработки данных.</li>\n<li><b>3 - DeleteAccountPolicy</b>: Политика удаления аккаунта</li>\n<li><b>4 - Offer</b>: Оферта</li>\n<li><b>5 - Regulation</b>: Устав</li>\n</ul>\n")
    })